import React from "react";
import { cards } from "./ProductosItems";
import "./Productos.css";

export const Productos = () => {
  return (
    <section className="productos" id="productos">
      <h3 className="productos-title">Nuestros productos</h3>
      <div className="productos-cardsContainer">
        {cards.map(({ id, background, title, text }) => (
          <div
            className="card"
            key={id}
            style={{ backgroundImage: `url(${background})` }}
          >
            <div className="card-background" />
            <div className="card-content">
              <h4 className="card-content-title">{title}</h4>
              <p className="card-content-text">{text}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
